module.exports = "<select [attr.disabled] = \"isReadOnly? true: null\" [(ngModel)]=\"selectedItemId\" class=\"form-control\" (ngModelChange)=\"onSelectedItemChange($event)\" id=\"streetSelectType\">\n  <option *ngFor =\"let i of items\" [value]=\"i.id\">\n    {{i.display}}\n  </option>\n</select>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/ref-data-dropdown/ref-data-dropdown.component.html
// module id = ./src/app/shared/components/ref-data-dropdown/ref-data-dropdown.component.html
// module chunks = main